"use strict";

$(() => {
  const $form = $("form.vendor-documents-form");

  if ($form.length === 0) {
    return;
  }

  const showFieldError = (fieldName, message) => {
    const $target = $form.find(`[data-error-for="${fieldName}"]`);

    if ($target.length) {
      if (message) {
        $target.text(message).show();
      } else {
        $target.text("").hide();
      }
    }
  };

  const clearFieldErrors = () => {
    $form.find("[data-error-for]").text("").hide();
  };

  const formatFileSize = (bytes) => {
    if (!bytes || bytes < 1) {
      return "";
    }

    const units = ["B", "KB", "MB", "GB"];
    let size = bytes;
    let unitIndex = 0;

    while (size >= 1024 && unitIndex < units.length - 1) {
      size /= 1024;
      unitIndex += 1;
    }

    const decimals = unitIndex === 0 ? 0 : 1;

    return `${size.toFixed(decimals)} ${units[unitIndex]}`;
  };

  const isImageFile = (name, type) => {
    if (type && /^image\//i.test(type)) {
      return true;
    }

    return /\.(jpe?g|png)$/i.test(name || "");
  };

  const isPdfFile = (name, type) => {
    return /\.pdf$/i.test(name || "") || type === "application/pdf";
  };

  const getFileTypeLabel = (name, type) => {
    if (isPdfFile(name, type)) {
      return "PDF";
    }

    if (isImageFile(name, type)) {
      return "Image";
    }

    return "";
  };

  const renderThumbIcon = ($thumb, iconClass) => {
    $thumb.html(
      `<span class="vendor-doc-upload__thumb-icon ${iconClass}" aria-hidden="true">` +
        `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-file-type-pdf">` +
        `<path stroke="none" d="M0 0h24v24H0z" fill="none"/>` +
        `<path d="M14 3v4a1 1 0 0 0 1 1h4" />` +
        `<path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" />` +
        `<path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6" />` +
        `<path d="M17 18h2" />` +
        `<path d="M20 15h-3v6" />` +
        `<path d="M11 15v6h1a2 2 0 0 0 2 -2v-2a2 2 0 0 0 -2 -2h-1z" />` +
        `</svg></span>`,
    );
  };

  const renderGenericIcon = ($thumb) => {
    $thumb.html(
      `<span class="vendor-doc-upload__thumb-icon" aria-hidden="true">` +
        `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-file">` +
        `<path stroke="none" d="M0 0h24v24H0z" fill="none"/>` +
        `<path d="M14 3v4a1 1 0 0 0 1 1h4" />` +
        `<path d="M5 12v-7a2 2 0 0 1 2 -2h7l5 5v4" />` +
        `<path d="M5 18h1.5a1.5 1.5 0 0 0 0 -3h-1.5v6" />` +
        `<path d="M17 18h2" />` +
        `<path d="M20 15h-3v6" />` +
        `</svg></span>`,
    );
  };

  const updatePreviewThumb = ($block, name, type, previewUrl) => {
    const $thumb = $block.find(".vendor-doc-upload__thumb");

    if (isImageFile(name, type) && previewUrl) {
      $thumb.html(`<img src="${previewUrl}" alt="" class="vendor-doc-upload__thumb-img" loading="lazy" />`);

      return;
    }

    if (isPdfFile(name, type)) {
      renderThumbIcon($thumb, "vendor-doc-upload__thumb-icon--pdf");

      return;
    }

    renderGenericIcon($thumb);
  };

  const setViewLink = ($block, previewUrl) => {
    const $view = $block.find('[data-action="view"]');

    if (previewUrl) {
      if ($view.length) {
        $view.attr("href", previewUrl).removeClass("is-hidden");
      } else {
        const label = $block.data("view-label") || "View";
        $block
          .find(".vendor-doc-upload__actions")
          .prepend(
            `<a href="${previewUrl}" class="vendor-doc-upload__action vendor-doc-upload__action--view" target="_blank" rel="noopener noreferrer" data-action="view">` +
              `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-external-link"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><path d="M12 6h-6a2 2 0 0 0 -2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-6" /><path d="M11 13l9 -9" /><path d="M15 4h5v5" /></svg>` +
              `<span>${label}</span></a>`,
          );
      }

      return;
    }

    $view.remove();
  };

  const showPreview = ($block, { name, size, type, previewUrl, storagePath }) => {
    const typeLabel = getFileTypeLabel(name, type);
    const sizeLabel = formatFileSize(size);
    const metaParts = [sizeLabel, typeLabel].filter(Boolean);

    $block.find(".vendor-doc-upload__name").text(name);
    $block
      .find(".vendor-doc-upload__meta")
      .html(metaParts.length ? metaParts.map((part, index) => (index > 0 ? `<span class="vendor-doc-upload__meta-sep" aria-hidden="true">·</span>${part}` : part)).join("") : "");

    updatePreviewThumb($block, name, type, previewUrl);
    setViewLink($block, previewUrl);

    $block.find(".vendor-doc-upload__empty").addClass("is-hidden");
    $block.find(".vendor-doc-upload__preview").removeClass("is-hidden");
  };

  const showEmpty = ($block) => {
    $block.find(".vendor-doc-upload__preview").addClass("is-hidden");
    $block.find(".vendor-doc-upload__empty").removeClass("is-hidden");
    $block.find(".vendor-doc-upload__input").val("").removeAttr("name");
    $block.find(".vendor-document-existing").remove();
    $block.removeData("object-url");
  };

  const syncFieldInputs = ($block, { storagePath = null, hasNewFile = false } = {}) => {
    const fieldName = $block.data("field-name");
    const $input = $block.find(".vendor-doc-upload__input");
    const $existing = $block.find(".vendor-document-existing");

    $input.removeAttr("name");
    $existing.remove();

    if (hasNewFile) {
      $input.attr("name", fieldName);

      return;
    }

    if (storagePath) {
      $block.find(".vendor-doc-upload__zone").append(`<input type="hidden" name="${fieldName}" value="${storagePath}" class="vendor-document-existing" />`);
    }
  };

  const initUploadBlock = ($block) => {
    const fieldName = $block.data("field-name");
    const isLocked = Number($block.data("locked")) === 1;
    const $input = $block.find(".vendor-doc-upload__input");
    let objectUrl = null;

    const existingFile = $block.data("existing-file");
    const existingName = $block.data("existing-name");

    if (existingFile && existingName) {
      showPreview($block, {
        name: existingName,
        size: Number($block.data("existing-size")) || 0,
        type: "",
        previewUrl: $block.data("existing-url"),
        storagePath: existingFile,
      });
      syncFieldInputs($block, { storagePath: existingFile });
    }

    if (isLocked) {
      return;
    }

    const revokeObjectUrl = () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        objectUrl = null;
      }
    };

    const openFilePicker = () => {
      $input.trigger("click");
    };

    $block.on("click", '.vendor-doc-upload__choose, [data-action="change"]', (event) => {
      event.preventDefault();
      openFilePicker();
    });

    $block.on("click", '[data-action="remove"]', (event) => {
      event.preventDefault();
      revokeObjectUrl();
      showEmpty($block);
      showFieldError(fieldName, "");
    });

    $input.on("change", function () {
      const file = this.files && this.files[0];

      revokeObjectUrl();
      $block.find(".vendor-document-existing").remove();
      showFieldError(fieldName, "");

      if (!file) {
        const existingFile = $block.data("existing-file");
        const existingUrl = $block.data("existing-url");
        const existingName = $block.data("existing-name");
        const existingSize = Number($block.data("existing-size")) || 0;

        if (existingFile && existingName) {
          showPreview($block, {
            name: existingName,
            size: existingSize,
            type: "",
            previewUrl: existingUrl,
            storagePath: existingFile,
          });

          syncFieldInputs($block, { storagePath: existingFile });
        } else {
          showEmpty($block);
        }

        return;
      }

      objectUrl = URL.createObjectURL(file);

      showPreview($block, {
        name: file.name,
        size: file.size,
        type: file.type,
        previewUrl: objectUrl,
        storagePath: null,
      });

      syncFieldInputs($block, { hasNewFile: true });
    });

  };

  $form.find(".vendor-doc-upload").each(function () {
    initUploadBlock($(this));
  });

  $form.on("submit", (event) => {
    event.preventDefault();

    if ($form.find('button[type="submit"]').length === 0) {
      return;
    }

    clearFieldErrors();

    const $button = $form.find("button[type=submit]");
    const formData = new FormData($form[0]);

    Botble.showButtonLoading($button);

    $httpClient
      .make()
      .post($form.prop("action"), formData)
      .then(({ data }) => {
        if (data.error) {
          Botble.showError(data.message);

          return;
        }

        Botble.showSuccess(data.message);
        window.location.reload();
      })
      .catch((error) => {
        const response = error.response;

        if (!response?.data) {
          Botble.showError(error.message || "Error");

          return;
        }

        if (response.data.message) {
          Botble.showError(response.data.message);
        }

        const errors = response.data.errors || response.data.data?.errors;

        if (errors) {
          Object.keys(errors).forEach((key) => {
            const message = Array.isArray(errors[key]) ? errors[key][0] : errors[key];

            showFieldError(key, message);
          });
        }
      })
      .finally(() => {
        Botble.hideButtonLoading($button);
      });
  });
});
